module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics/cd1//Track_32_Story_9_Let_s_Dance.mp3";